import { render, staticRenderFns } from "./CmgOrderCard.vue?vue&type=template&id=c84ace30&scoped=true&lang=pug"
import script from "./cmg-order-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderCard.vue?vue&type=style&index=0&id=c84ace30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ace30",
  null
  
)

export default component.exports